import { createAction } from '@ngrx/store';

export const toggleSidebarAdmin = createAction('[Admin UI] Toggle Sidebar');
export const closeSidebarAdmin = createAction('[Admin UI] Close Sidebar');
